<template>
  <div>
    <div
      v-for="localBoundingBox in boundingBoxes"
      :key="`${localBoundingBox.top}, ${localBoundingBox.left}`"
      class="overlay"
      :style="getStyle(localBoundingBox)"
    ></div>
  </div>
</template>

<script>
import { FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA } from '@/constants/colors';

export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    boundingBoxes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStyle(localBoundingBox) {
      const backgroundColor = FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA;

      return {
        position: `absolute`,
        height: `${localBoundingBox.height}px`,
        width: `${localBoundingBox.width}px`,
        top: `${localBoundingBox.top - this.boundingBox.top}px`,
        left: `${localBoundingBox.left - this.boundingBox.left}px`,
        background: backgroundColor,
        borderRadius: 0,
      };
    },
  },
};
</script>
